export class Form {
    constructor(formTitle) {
        this.formTitle = formTitle;
    }

    schema() {
        return [
            {
                'component': 'h2',
                'children': this.formTitle,
            },
            {
                'component': 'div',
                'class': 'row',
                'children': [
                    {
                        'type': 'text',
                        'name': 'name',
                        'label': 'Name',
                        'class': 'col-12',
                        'placeholder': 'Bitte Namen eingeben...',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Name',
                    },
                    {
                        'type': 'checkbox',
                        'name': 'active',
                        'label': 'Aktiv',
                        'class': 'col-12 checkbox',
                        'validation': 'optional',
                        'validation-name': 'Status',
                    },
                    {
                        'type': 'editor',
                        'name': 'description',
                        'label': 'Beschreibung',
                        'class': 'col-12',
                        'validation': 'required',
                        'validation-name': 'Beschreibung',
                    },
                    {
                        'type': 'cropper',
                        'aspectRatio': 4 / 3,
                        'name': 'media',
                        'label': 'Bild',
                        'class': 'col-12',
                        'uploadBehavior': 'delayed',
                        'validation': 'optional|mime:image/jpeg,image/png',
                        'validation-name': 'Bild',
                        'help': 'Wählen Sie ein PNG oder JPG zum Hochladen aus.',
                    },
                    {
                        'type': 'file',
                        'name': 'file',
                        'label': 'Datei',
                        'class': 'col-12',
                        'uploadBehavior': 'delayed',
                        'validation': 'optional|mime:application/pdf',
                        'validation-name': 'Datei',
                        'help': 'Wählen Sie ein PDF zum Hochladen aus.',
                    },
                ],
            },
        ];
    }
}
